import React from "react";
import ProductDetail from "../components/ProductDetail/ProductDetail";

export default function DetailofProduct() {
    return (
        <>
            <ProductDetail />
        </>
    );
}
